exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".boxLight---2hoK0,.container---37Vwu{display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex}.container---37Vwu{-webkit-box-align:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-webkit-box-shadow:3px 3px 1px #e7e9ea;box-shadow:3px 3px 1px #e7e9ea;min-width:20%;height:36px;border:1px solid #e1e1e1;border-radius:5px;margin-bottom:14px;background-color:#fff;color:#4e5c67;font-family:Poppins;font-size:14px;font-weight:500;text-align:center;cursor:pointer}.wrapper---fx-pn{width:100%;outline:none}.wrapper---fx-pn span{width:80%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.icon---3zFgy{width:20px;height:21px;margin-right:10px;float:right}", ""]);

// exports
exports.locals = {
	"boxLight": "boxLight---2hoK0",
	"container": "container---37Vwu",
	"wrapper": "wrapper---fx-pn",
	"icon": "icon---3zFgy"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader/dist/cjs.js?{"implementation":{"info":"dart-sass/t1.26.11/t(Sass Compiler)/t[Dart]/ndart2js/t2.9.3/t(Dart Compiler)/t[Dart]","types":{},"NULL":{},"TRUE":{"value":true},"FALSE":{"value":false}},"includePaths":["/usr/src/app/node_modules"]}!./app/components/button/box.scss
// module id = 749
// module chunks = 3